export type HTTPMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH" | "HEAD" | "OPTIONS";


export class HTTPRequest {
    method: HTTPMethod
    url: string
    body: any
    headers:  { [key: string]: string }
    responseType: ResponseType
    signal?: AbortSignal;
}

export interface HTTPClientInterface {
    retryCallback?: (request: HTTPRequest, errorCode: number, attemptNumber: number) => Promise<boolean>
    verbose: boolean
    setClientHeaders(headers: Record<string, string>): void
    execute(request: HTTPRequest, retryCount?: number): Promise<any>
}

export type ResponseType = "auto" | "json" | "text" | "blob" | "arrayBuffer";